"use client";

import { createFileRoute, Outlet } from "@tanstack/react-router";

/**
 * Rahmen der Vorlagen-Unterseiten (Kämmerei, Krisenplan). Der frühere
 * Sammelpfad leitet über `vorlagen.index` auf die Kämmerei-Vorlage um.
 */
export const Route = createFileRoute("/_cockpit/cockpit/hundert-tage/vorlagen")({
  component: () => <Outlet />,
});
